import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Spacer from "../../common/Spacer";
import "./Sidebar.css";
import CreateCarePlan from "../CarePlan/CreateCarePlan";
import {
  PlusIcon,
  HomeIcon,
  DraftIcon,
  CarePlanIcon,
  BuilderIcon,
  UsersIcon,
  GuideIcon,
  // ReportsIcon,
  LogIcon,
} from "../../common/Icons";

const ACTIVE_COLOR = "#051819";

const Sidebar = ({ userType, isOpen, className }) => {
  const [showCreateCarePlan, setShowCreateCarePlan] = useState(false);
  // Replace this with your actual logic to get user type
  // const [userType, setUserType] = useState("admin"); // Example: Can be 'admin' or 'mdt'

  const adminLinks = [
    { to: "/admin_dashboard/overview", label: "Overview", icon: HomeIcon },
    {
      to: "/admin_dashboard/draft-care-plans",
      label: "Draft Care Plans",
      icon: DraftIcon,
    },
    {
      to: "/admin_dashboard/active-care-plans",
      label: "Active Care Plans",
      icon: CarePlanIcon,
    },
    {
      to: "/admin_dashboard/care-plan-builder",
      label: "Care Plan Builder",
      icon: BuilderIcon,
    },
    {
      to: "/admin_dashboard/mdt-users",
      label: "Users",
      icon: UsersIcon,
    },
    {
      to: "/admin_dashboard/audit-log",
      label: "Audit Log",
      icon: LogIcon,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      to: "/admin_dashboard/user-guide",
      label: "User Guides",
      icon: GuideIcon,
    },
    // {
    //   to: "/admin_dashboard/reports",
    //   label: "Reports",
    //   icon: ReportsIcon,
    // },
  ];

  const mdtLinks = [
    { to: "/mdt_dashboard/overview", label: "Overview", icon: HomeIcon },
    {
      to: "/mdt_dashboard/draft-care-plans",
      label: "Draft Care Plans",
      icon: DraftIcon,
    },
    {
      to: "/mdt_dashboard/active-care-plans",
      label: "Active Care Plans",
      icon: CarePlanIcon,
    },
    {
      to: "/mdt_dashboard/user-guide",
      label: "User Guides",
      icon: GuideIcon,
    },
  ];

  const links = userType === "admin" ? adminLinks : mdtLinks;
  return (
    <>
      {showCreateCarePlan && (
        <CreateCarePlan onClose={() => setShowCreateCarePlan(false)} />
      )}
      <aside className={`sidebar ${isOpen ? "open" : ""} ${className}`}>
        <div className="sidebar-logo-container">
          <img src="/assets/SidebarLogoImage.svg" alt="Sidebar Logo" />
        </div>
        <Spacer height="28px" />
        <button
          className="new-care-plan-btn"
          onClick={() => setShowCreateCarePlan(true)}
        >
          <PlusIcon color="#ffffff" /> <span>New Care Plan</span>
        </button>
        <Spacer height="42px" />
        <nav>
          <ul>
            {links.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {({ isActive }) => (
                    <>
                      {React.createElement(link.icon, {
                        color: isActive ? ACTIVE_COLOR : undefined,
                        ...link.iconProps,
                      })}
                      {link.label}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
